// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"0b5e4d38","180":"33028f5f","181":"77a969e9","251":"f27fc6ab","357":"8a3bdcbb","453":"9d5e10b2","468":"342bdfe5","517":"c8496a37","791":"eeafb606","833":"2539b7aa","888":"f0476959","957":"f0a44707","999":"1563ab6a"}[chunkId] + ".chunk.js";
};